import React, { ReactNode } from 'react'

import useLazyLoadScript from '@web/hooks/useLazyLoadScript'
import { PHASE } from '@web/libs/constants'
import { extractErrorMessage, neloLogger } from '@web/libs/utils'

interface WithLazyLoadScriptProps {
  /**
   * 로드할 외부 JS 파일의 주소
   */
  src: string
  /**
   * 로드가 완료되면 렌더링할 자식 컴포넌트
   */
  children?: ReactNode
  /**
   * 에러 발생시 폴백, 기본값은 null 로 리턴
   */
  fallback?: ReactNode
  /**
   * 로딩 컴포넌트, 기본값은 null 로 리턴
   */
  loader?: ReactNode
}

const WithLazyLoadScript: React.FC<WithLazyLoadScriptProps> = ({ src, children, fallback, loader }) => {
  const { error, loading } = useLazyLoadScript(src, {
    onError: () => {
      if (PHASE === 'development' || PHASE === 'qa') console.error({ error })

      const metadata = {
        userAgent: window.navigator.userAgent,
        page: window.location.href,
        referer: window.document.referrer,
      }

      neloLogger('error', extractErrorMessage(error), metadata)
    },
  })

  if (error) return fallback

  if (loading) return loader

  return children
}

export default WithLazyLoadScript
